export default __webpack_public_path__ + "static/btn-7774955cd9be1db3e4e49458c3e73068.png";